import { md5Base64 } from '@/lib/md5'
import { api, type ApiClient } from './client'
import { ApiError } from './errors'
import type {
  ConfirmUploadResponse,
  CreateUploadRequest,
  CreateUploadResponse,
  UploadResourceType,
} from './pending'

export interface UploadParams {
  file: File
  resourceType: UploadResourceType
  condominiumId: number
}

export interface UploadResult extends ConfirmUploadResponse {
  upload_id: string
}

/**
 * Three-step upload: create (with the file's base64 MD5) → PUT the bytes to the signed URL
 * (no Authorization header, only the signed content type) → confirm.
 */
export async function uploadFile(
  { file, resourceType, condominiumId }: UploadParams,
  client: ApiClient = api,
  putFetch: typeof fetch = (...a) => fetch(...a),
): Promise<UploadResult> {
  const created = await client.post<CreateUploadResponse>('/uploads', {
    resource_type: resourceType,
    condominium_id: condominiumId,
    content_type: file.type,
    size: file.size,
    md5: await md5Base64(file),
  } satisfies CreateUploadRequest)

  const put = await putFetch(created.upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  })
  if (!put.ok) throw new ApiError(put.status, 'Falha ao enviar o arquivo', '')

  const confirmed = await client.post<ConfirmUploadResponse>('/uploads/:id/confirm', undefined, {
    params: { id: created.upload_id },
  })
  return { upload_id: created.upload_id, ...confirmed }
}
